import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { environment } from "src/environments/environment";
import { Action, Store } from '@ngrx/store';
import { AppState } from 'src/app/reducers';
import { ToastService } from 'src/app/services/toast.service';
import { EmailService } from '../../services/email.service';
import { EmailsRequested, EmailActionTypes, EmailsLoaded, EmailsCancelled, EmailToggleMarkedRequested, EmailToggleMarkedCancelled, EmailToggleMarkedLoaded, EmailsRight, EmailAccesoRequested, EmailAccesoLoaded, EmailAccesoCancelled } from './email.actions';
import { switchMap, catchError, map, withLatestFrom, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { AccesoEmailMarkable, AccesosEmails } from "src/common/acceso";
import { emailDelegados, emailPersonal } from "./email.selectors";
import { Observable } from "rxjs";
import { sessionIsUsuarioExterno } from "src/app/session/store/session.selectors";


@Injectable()
export class EmailEffects {

	emailData$ = createEffect( () =>{
		return this.actions$.pipe(
			ofType<EmailsRequested>( EmailActionTypes.EmailsRequested ),
			withLatestFrom( this.store.select( sessionIsUsuarioExterno ), this.store.select( emailPersonal ) ),
			switchMap( ([ action, isUsuarioExterno, emailPersonal ]) => {
				let resultAction: Observable<Action>;

				// Solo si se está cargando por primera vez.
				// Si es la primera vez, emailPersonal será null. En caso contrario, no se busca nuevamente.
				if( !isUsuarioExterno && !emailPersonal ) {
					resultAction = this.service.findEmails()
						.pipe(
							map( (accesos: AccesosEmails) => {
								let personal = accesos.personal;
								let delegados = accesos.delegados;
								return new EmailsLoaded( { personal, delegados } );
							}),
							catchError( error => {
								this.toastService.danger( "No se pudieron obtener los emails" );
								return of( new EmailsCancelled() );
							})
						);
				} else {
					resultAction = of( new EmailsRight() );
				}

				return resultAction;
			})
		);
	});

	toggleMarked$ = createEffect( () => {
		return this.actions$.pipe(
			ofType<EmailToggleMarkedRequested>( EmailActionTypes.EmailToggleMarkedRequested ),
			withLatestFrom( this.store.select( emailDelegados ) ),
			switchMap( ([ action, emails ]) => {
				let acceso: AccesoEmailMarkable = action.payload;
				let observable: Observable<Object> = acceso.marked? this.service.removeEmailFavorito( acceso.id ): this.service.addEmailFavorito( acceso.id, acceso.emailAbreviado );
				return observable
					.pipe(
						map( () => new EmailToggleMarkedLoaded( acceso.id ) ),
						catchError( error => {
							this.toastService.danger( "La operación no pudo realizarse" );
							return of( new EmailToggleMarkedCancelled( acceso.id ) );
						})
					)
			})
		);
	});

	emailAccesoRequested$ = createEffect( () =>{
		return this.actions$.pipe(
			ofType<EmailAccesoRequested>( EmailActionTypes.EmailAccesoRequested ),
			switchMap( action => {
				let emailCompleto: string = action["payload"]["emailCompleto"];
				return this.service.getEmailAcceso( emailCompleto ).pipe(
						tap( () => {
							window.open( environment.mailboxUrl );
						}),
						map( () => new EmailAccesoLoaded() ),
						catchError( error => {
							this.toastService.danger( "No se pudo obtener el acceso al email" );
							return of( new EmailAccesoCancelled() );
						})
					);
			})
		);
	});

    constructor( private actions$: Actions, private store: Store<AppState>, private service: EmailService, private toastService: ToastService ) {
	}

}